import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';


const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({
      smoothWheel: true,
      lerp: 0.05,
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      syncTouch: true,
      syncTouchLerp: 0.1,
      touchInertiaMultiplier: 50,
      wheelMultiplier: 0.75,
      touchMultiplier: 0.75,
      normalizeWheel: false,
      infinite: false,
      autoResize: true,
    });

    window.lenis = lenis;
    window.__modalOpen = false;

    const handleLinkClick = (event) => {
      const target = event.target.closest('a, button, .blogArticle');
      if (!target) return;

      if (target.hasAttribute('download')) return;
      if (target.hasAttribute('target')) return;

      // Skip in-page hash links — they are handled by the article's own click
      // handler (scrollIntoView). If we let them fall through here, lenis would
      // immediately scroll back to 0 and flash the loading overlay.
      if (target.tagName === 'A') {
        const href = target.getAttribute('href') || '';
        if (href.startsWith('#')) return;
        // Also skip absolute-URL links that point to the current page + a hash
        const currentPageUrl = window.location.origin + window.location.pathname;
        if (href.includes('#') && href.startsWith(currentPageUrl)) return;
      }

      const isSmoothLink =
        target.tagName === 'A' ||
        (target.tagName === 'BUTTON' && target.classList.contains('page-link')) ||
        target.classList.contains('blogArticle');

      if (!isSmoothLink) return;

      event.preventDefault();

      const loadingOverlay = document.getElementById('loading-overlay');

      lenis.scrollTo(0, {
        immediate: true,
        onComplete: () => {
          loadingOverlay?.classList.add('active');
        },
      });

      setTimeout(() => {
        loadingOverlay?.classList.remove('active');
      }, 500);
    };

    let rafId;

    const raf = (time) => {
      if (!window.__modalOpen) {
        lenis.raf(time);
      }
      rafId = requestAnimationFrame(raf);
    };

    rafId = requestAnimationFrame(raf);
    document.addEventListener('click', handleLinkClick);

    return () => {
      lenis.destroy();
      window.lenis = null;
      window.__modalOpen = false;
      document.removeEventListener('click', handleLinkClick);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return null;
};

export default SmoothScroll;